var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMicrosoftPowerpointLogo = function SvgIconMicrosoftPowerpointLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.688 9.75a1 1 0 0 1 1-1h1.5a2.5 2.5 0 0 1 0 5h-.5v.5a1 1 0 1 1-2 0zm2 2h.5a.5.5 0 0 0 0-1h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.264 5.375a10 10 0 1 1 0 13.25H3.75A1.75 1.75 0 0 1 2 16.875v-9.75c0-.966.784-1.75 1.75-1.75zm5.287-1.066A8 8 0 0 1 20.69 11H16V7.125a1.75 1.75 0 0 0-1.75-1.75H8.27a8 8 0 0 1 2.28-1.066M5.719 7.375H14v9.25H4v-9.25zm2.55 11.25a8 8 0 0 0 7.135.924A8 8 0 0 0 20.69 13H16v3.875a1.75 1.75 0 0 1-1.75 1.75z"
  }))));
};
export default SvgIconMicrosoftPowerpointLogo;